import { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export function Section({ index, title, children, testid }) {
  return (
    <section data-testid={testid} className="border-t border-white/10 pt-8">
      <h2 className="flex items-baseline gap-4 font-display text-xl font-black uppercase tracking-tight text-white">
        <span className="font-tac text-xs text-[#F5B301]">{index}</span>
        {title}
      </h2>
      <div className="mt-4 space-y-3 font-tac text-sm leading-relaxed text-[#A1A1AA]">
        {children}
      </div>
    </section>
  );
}

export default function LegalLayout({ label, title, testid, children }) {
  useEffect(() => {
    document.title = `${title} — DROPS TFR`;
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [title]);

  return (
    <div className="min-h-screen bg-[#09090B] text-white selection:bg-[#F5B301] selection:text-black">
      <div className="grain" aria-hidden="true" />
      <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/50 backdrop-blur-xl">
        <div className="flex items-center justify-between px-6 py-4 lg:px-16">
          <a href="/" data-testid="legal-logo" className="group flex items-center gap-3">
            <img
              src="/assets/logo.png"
              alt="DROPS TFR Wappen"
              className="h-10 w-10 object-contain transition-transform duration-300 group-hover:scale-110"
            />
            <span className="font-display text-lg font-black uppercase tracking-tighter">
              Drops<span className="text-[#F5B301]"> TFR</span>
            </span>
          </a>
          <a
            href="/"
            data-testid="legal-back-link"
            className="group flex items-center gap-2 font-tac text-xs tracking-[0.2em] text-white/70 transition-colors duration-300 hover:text-white"
          >
            <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
            STARTSEITE
          </a>
        </div>
      </header>

      <motion.main
        data-testid={testid}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto max-w-3xl px-6 pb-32 pt-40"
      >
        <p className="font-tac text-xs tracking-[0.3em] text-[#F5B301]">{label}</p>
        <h1 className="mt-4 font-display text-5xl font-black uppercase tracking-tighter sm:text-6xl">
          {title}
        </h1>
        <div className="mt-14 space-y-12">{children}</div>
      </motion.main>

      <footer className="border-t border-white/10 px-6 py-8 text-center font-tac text-[10px] tracking-[0.25em] text-white/40">
        © 2026 DROPS TFR — SCHNELL. TECHNISCH. ZUVERLÄSSIG.
      </footer>
    </div>
  );
}
